<template>
  <div>
    <router-view v-if="isOrgAdmin" :key="$route.name"></router-view>
    <empty-page v-else type="permission"></empty-page>
    <i-toast />
  </div>
</template>

<script>
import EmptyPage from '@/shared/components/EmptyPage.vue';
import { iToast } from '@inscribe/signal';
import { mapGetters } from 'vuex';

export default {
  components: {
    EmptyPage,
    'i-toast': iToast,
  },
  computed: {
    ...mapGetters({
      isOrgAdmin: 'isOrgAdmin',
    }),
  },
};
</script>
